const SEARCH_PIN_KEY = 'procmart_search_pinned';

// Fallback in-memory storage if localStorage is not available
let fallbackStorage = new Map();

const isLocalStorageAvailable = () => {
    try {
        const test = '__localStorage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        console.error('localStorage not available:', e);
        return false;
    }
};

export const getSearchPinState = () => {
    try {
        console.log('=== getSearchPinState called ===');
        
        if (!isLocalStorageAvailable()) {
            console.log('localStorage not available, using fallback');
            const fallbackValue = fallbackStorage.get(SEARCH_PIN_KEY);
            const result = fallbackValue === undefined ? true : fallbackValue;
            console.log('fallback result:', result);
            return result;
        }
        
        console.log('localStorage is available');
        const pinned = localStorage.getItem(SEARCH_PIN_KEY);
        console.log('localStorage.getItem result:', pinned);
        
        const result = pinned === null ? true : JSON.parse(pinned);
        console.log('final result:', result);
        return result;
    } catch (error) {
        console.error('Error reading search pin state from localStorage:', error);
        // Fallback to in-memory storage
        const fallbackValue = fallbackStorage.get(SEARCH_PIN_KEY);
        const result = fallbackValue === undefined ? true : fallbackValue;
        console.log('error fallback result:', result);
        return result;
    }
};

export const setSearchPinState = (isPinned) => {
    try {
        console.log('=== setSearchPinState called with:', isPinned === true ? 'true' : 'false', '===');
        
        if (!isLocalStorageAvailable()) {
            console.log('localStorage not available, using fallback storage');
            fallbackStorage.set(SEARCH_PIN_KEY, isPinned);
            console.log('fallback storage set successfully');
            return;
        }
        
        console.log('Setting localStorage item...');
        localStorage.setItem(SEARCH_PIN_KEY, JSON.stringify(isPinned));
        console.log('localStorage set successfully');
        
        // Verify the write
        const verify = localStorage.getItem(SEARCH_PIN_KEY);
        console.log('Verification - localStorage now contains:', verify);
        
    } catch (error) {
        console.error('Error writing search pin state to localStorage:', error);
        // Fallback to in-memory storage
        fallbackStorage.set(SEARCH_PIN_KEY, isPinned);
        console.log('Error fallback storage set successfully');
    }
};

export const toggleSearchPinState = () => {
    console.log('=== toggleSearchPinState called ===');
    const currentState = getSearchPinState();
    console.log('Current state:', currentState);
    const newState = !currentState;
    console.log('New state:', newState);
    setSearchPinState(newState);
    return newState;
};

export const isSearchPinned = () => {
    return getSearchPinState();
};
 